import React from "react";

interface LockIconProps {
  className?: string;
  onClick?: () => void;
}

export const LockIcon = ({ className, onClick }: LockIconProps) => (
  <svg
    className={className}
    onClick={onClick}
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1562 19.4062C10.9688 19.5938 10.75 19.6875 10.5 19.6875C10.25 19.6875 10.0312 19.5938 9.84375 19.4062C9.65625 19.2188 9.5625 19 9.5625 18.75V15.75C9.5625 15.5 9.65625 15.2812 9.84375 15.0938C10.0312 14.9062 10.25 14.8125 10.5 14.8125C10.75 14.8125 10.9688 14.9062 11.1562 15.0938C11.3438 15.2812 11.4375 15.5 11.4375 15.75V18.75C11.4375 19 11.3438 19.2188 11.1562 19.4062ZM21 12.75V21.75C21 22.375 20.7812 22.9062 20.3438 23.3438C19.9062 23.7812 19.375 24 18.75 24H2.25C1.625 24 1.09375 23.7812 0.65625 23.3438C0.21875 22.9062 0 22.375 0 21.75V12.75C0 12.125 0.21875 11.5938 0.65625 11.1562C1.09375 10.7188 1.625 10.5 2.25 10.5H3V7.5C3 5.4375 3.73438 3.67187 5.20312 2.20312C6.67188 0.734375 8.4375 0 10.5 0C12.5938 0 14.3594 0.75 15.7969 2.25C17.2656 3.71875 18 5.5 18 7.59375V10.5H18.75C19.375 10.5 19.9062 10.7188 20.3438 11.1562C20.7812 11.5938 21 12.125 21 12.75ZM4.5 10.5H16.5V7.5C16.5 5.84375 15.9062 4.4375 14.7188 3.28125C13.5625 2.09375 12.1562 1.5 10.5 1.5C8.84375 1.5 7.42188 2.09375 6.23438 3.28125C5.07812 4.4375 4.5 5.84375 4.5 7.5V10.5ZM19.5 21.75V12.75C19.5 12.5312 19.4219 12.3594 19.2656 12.2344C19.1406 12.0781 18.9688 12 18.75 12H2.25C2.03125 12 1.84375 12.0781 1.6875 12.2344C1.5625 12.3594 1.5 12.5312 1.5 12.75V21.75C1.5 21.9688 1.5625 22.1406 1.6875 22.2656C1.84375 22.4219 2.03125 22.5 2.25 22.5H18.75C18.9688 22.5 19.1406 22.4219 19.2656 22.2656C19.4219 22.1406 19.5 21.9688 19.5 21.75Z"
      fill="black"
    />
  </svg>
);

LockIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
